/**
 * Prefilled rubric name for a variant, numbered by its position in the rubric
 * type's authoring order.
 *
 * The number is what orders the rubric. `sortRubrics` breaks ties on the rubric
 * name, and variant-stamped rubrics are all scoped to "all slides", so they tie
 * on both slide tiers and the name is the only thing separating them. Without a
 * number they read alphabetically, which is not the sequence the presets were
 * authored in.
 *
 * Numbering is positional rather than `variant.order + 1` so the sequence always
 * reads 1..N even if the seeded `order` values are non-contiguous. Pass the full
 * variant list, never a filtered subset, or the numbers shift.
 *
 * The name is only a default. An author renames a rubric to move it, and a
 * rubric type with no variants is numbered by hand the same way.
 *
 * Numbers are unpadded, so this mis-sorts past nine variants ("10." compares
 * before "2."). Zero-pad here if a type ever ships that many.
 */
export function variantRubricName(
  variants: { variantKey: string; title: string }[],
  variantKey: string
): string {
  const index = variants.findIndex(
    (variant) => variant.variantKey === variantKey
  )
  if (index < 0) return ''
  return `${index + 1}. ${variants[index].title}`
}
